import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, SparklesIcon } from 'lucide-react';
export function OfferSection() {
  const handleCTAClick = () => {
    window.location.href = 'https://claridapaso.com/cart/48538406093043:1';
  };
  return <section id="offer-section" className="w-full py-20 px-4 bg-navy-light relative overflow-hidden" data-id="element-143">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10" data-id="element-144">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gold rounded-full blur-3xl" data-id="element-145" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-gold-light rounded-full blur-3xl" data-id="element-146" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-148">
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mb-8" data-id="element-149">
            <SparklesIcon className="w-16 h-16 text-gold mx-auto mb-4" aria-hidden="true" data-id="element-150" />
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black mb-4" data-id="element-151">
              <span className="text-gold-metallic" data-id="element-152">
                Tu Inversión en un Mejor Futuro Financiero
              </span>
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-navy-lighter border-2 border-gold rounded-3xl p-8 md:p-12 mb-10" data-id="element-153">
            <p className="text-gray-300 text-lg mb-6" data-id="element-154">
              Este manual no cuesta cientos de dólares.
            </p>

            <div className="space-y-4 mb-10 max-w-md mx-auto text-left" data-id="element-155">
              <div className="flex items-start gap-3" data-id="element-156">
                <CheckCircleIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" aria-hidden="true" data-id="element-157" />
                <p className="text-lg text-gray-300" data-id="element-158">
                  <strong className="text-white" data-id="element-159">Acceso de por vida</strong> al
                  manual completo
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-160">
                <CheckCircleIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" aria-hidden="true" data-id="element-161" />
                <p className="text-lg text-gray-300" data-id="element-162">
                  <strong className="text-white" data-id="element-163">Plantillas y guías</strong>{' '}
                  paso a paso
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-164">
                <CheckCircleIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" aria-hidden="true" data-id="element-165" />
                <p className="text-lg text-gray-300" data-id="element-166">
                  <strong className="text-white" data-id="element-167">
                    Actualizaciones incluidas
                  </strong>{' '}
                  cuando mejoremos el contenido
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-168">
                <CheckCircleIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" aria-hidden="true" data-id="element-169" />
                <p className="text-lg text-gray-300" data-id="element-170">
                  <strong className="text-white" data-id="element-171">Descarga inmediata</strong> en
                  formato PDF
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-172">
                <CheckCircleIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" aria-hidden="true" data-id="element-173" />
                <p className="text-lg text-gray-300" data-id="element-174">
                  La información que{' '}
                  <strong className="text-white" data-id="element-175">cambiará tus finanzas</strong>
                </p>
              </div>
            </div>

            <motion.button id="cta-button" onClick={handleCTAClick} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} className="w-full md:w-auto px-12 py-5 bg-gradient-to-r from-gold-light via-gold to-gold-dark text-navy text-xl md:text-2xl font-heading font-black rounded-xl shadow-2xl btn-pulse hover:shadow-gold/50 transition-all duration-300 mb-8" aria-label="Comprar guía para mejorar crédito" data-id="element-176">
              👉 QUIERO MEJORAR MI CRÉDITO
            </motion.button>

            <div className="mb-6" data-id="element-177">
              <div className="flex flex-col items-center justify-center gap-3 mb-4" data-id="element-178">
                <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-179">
                  <span className="text-gray-400 line-through text-4xl md:text-5xl font-heading font-bold" data-id="element-180">
                    $19.00
                  </span>
                  <span className="bg-gradient-to-r from-gold-light to-gold text-navy px-4 py-2 rounded-full text-lg md:text-xl font-heading font-black shadow-lg" data-id="element-181">
                    AHORRA 67%
                  </span>
                </div>
                <span className="text-gold-light text-2xl md:text-3xl font-heading font-bold" data-id="element-182">
                  Por solo:
                </span>
              </div>
              <div className="text-7xl md:text-8xl font-heading font-black text-gold-metallic mb-2" data-id="element-183">
                $6.36
              </div>
              <p className="text-xl text-gray-300" data-id="element-184">Un solo pago</p>
            </div>

            <p className="text-sm text-gray-400" data-id="element-185">
              Pago único. Sin suscripciones. Sin cargos ocultos.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="text-center" data-id="element-186">
            <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-187">
              Cada vez más personas están aprendiendo a organizar mejor su
              crédito con esta guía.{' '}
              <strong className="text-gold-light" data-id="element-188">Es tu momento</strong>.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}